import React, { useEffect, useState } from "react";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";

const LineStateActivityUpdate = ({
  item,
  setItem,
  selectedStateMachineBlueprint,
  setSelectedStateMachineBlueprint,
  activitiesObject,
  statesObject
}) => {
  const [currentState, setCurrentState] = useState();
  let activitiesKeyArray = Object.keys(activitiesObject);
  let rememberItemsArray = ["allow_activities"];

  const findChange = (oldArray, newArray) => {
    // Convert arrays of objects into sets of IDs for easier comparison
    const oldIds = new Set(oldArray.map((item) => item.id));
    const newIds = new Set(newArray.map((item) => item.id));

    // Determine if there's an addition or removal
    const addedIds = [...newIds].filter((id) => !oldIds.has(id));
    const removedIds = [...oldIds].filter((id) => !newIds.has(id));

    // Return the result in the specified format
    if (addedIds.length > 0) {
      return { type: "add", id: addedIds[0] }; // Return the first added ID
    } else if (removedIds.length > 0) {
      return { type: "remove", id: removedIds[0] }; // Return the first removed ID
    } else {
      // If no changes, return null or an empty object
      return null;
    }
  };

  const handleChangeInArray = (values, key) => {
    const { type, id } = findChange(item.activities, values);
    if (type === "add") {
      addInRememberArray(id, key);
    } else if (type === "remove") {
      removeInRememberArray(id, key);
    }
  };

  const addInRememberArray = (value, key) => {
    // adding a data in line
    const copyItem = JSON.parse(JSON.stringify(item));
    copyItem.activities = [...copyItem.activities, { id: value, name: activitiesObject[value].name }];
    setItem(copyItem);
    const sourceStateID = item.source;
    const copyBluePrint = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));

    // state update
    const sourceStateIndex = copyBluePrint.states.findIndex((state) => state.id === sourceStateID);
    if (sourceStateIndex !== -1) {
      const sourceStateData = copyBluePrint.states[sourceStateIndex];
      if (!sourceStateData.remember[key].includes(value)) {
        sourceStateData.remember[key].push(value);
        copyBluePrint.states[sourceStateIndex] = sourceStateData;
        setCurrentState(sourceStateData);
      }
    }
    // activity update
    const actIndex = copyBluePrint.activities.findIndex((act) => act.id === value);
    const activity = copyBluePrint.activities[actIndex];
    if (activity) {
      const isTargetPresent = activity.state_change_logic.some((obj) => obj.state_id === item.target);
      if (!isTargetPresent && item?.type !== "gateway") {
        activity.state_change_logic = [...activity.state_change_logic, { state_id: item.target, condition: "true" }];
      }
      if (item?.type === "gateway") {
        const isGatewayPresent = activity?.gateway_change_logic?.some((obj) => obj.gateway_id === item.target);
        if (!isGatewayPresent) {
          if (!activity.gateway_change_logic) {
            activity.gateway_change_logic = [];
          }
          activity.gateway_change_logic = [
            ...activity.gateway_change_logic,
            { gateway_id: item.target, condition: "true" }
          ];
        }
      }
      copyBluePrint.activities[actIndex] = activity;
    }
    setSelectedStateMachineBlueprint(copyBluePrint);
  };

  const removeInRememberArray = (value) => {
    const copyBluePrint = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));
    const copyItem = JSON.parse(JSON.stringify(item));
    const newItemActivities = copyItem.activities.filter((obj) => obj.id !== value);

    copyItem.activities = newItemActivities;
    setItem(copyItem);
    // activity update
    const actIndex = copyBluePrint.activities.findIndex((act) => act.id === value);
    const activity = copyBluePrint.activities[actIndex];
    if (activity) {
      const isTargetPresent = activity.state_change_logic.some((obj) => obj.state_id === item.target);
      if (isTargetPresent) {
        activity.state_change_logic = activity.state_change_logic.filter((obj) => obj.state_id !== item.target);
        // [...activity.state_change_logic, { state_id: item.target, condition: "true" }];
      }
      if (item?.type === "gateway") {
        const isGatewayPresent = activity?.gateway_change_logic?.some((obj) => obj.gateway_id === item.target);
        if (isGatewayPresent) {
          activity.gateway_change_logic = activity.gateway_change_logic.filter((obj) => obj.gateway_id !== item.target);
        }
      }
      copyBluePrint.activities[actIndex] = activity;
    }
    setSelectedStateMachineBlueprint(copyBluePrint);
  };

  useEffect(() => {
    setCurrentState(statesObject[item.source]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!currentState) return;
  return (
    <div className="sm_blueprint_editBox">
      <div className="mb_2">
        <label className="builder_label">{currentState.name}</label>
      </div>
      {/* 
      {rememberItemsArray.map((rememberKey) => {
        let rememberArray = currentState.remember[rememberKey];

        let activitiesNameArray = [];
        for (let index = 0; index < activitiesKeyArray.length; index++) {
          const activitiesKey = activitiesKeyArray[index];
          if (!activitiesKey || !activitiesObject[activitiesKey]) continue;
          activitiesNameArray.push({
            name: activitiesObject[activitiesKey].name,
            id: activitiesKey
          });
        }
        let rememberNameArray = [];
        for (let index = 0; index < rememberArray.length; index++) {
          const activitiesKey = rememberArray[index];
          if (!activitiesKey || !activitiesObject[activitiesKey]) continue;
          rememberNameArray.push({
            name: activitiesObject[activitiesKey].name,
            id: activitiesKey
          });
        }
        return (
          <MultiSelectBox
            key={rememberKey}
            label={rememberKey.split("_").join(" ")}
            options={activitiesNameArray}
            selectedData={item.activities}
            onChange={(newData) => handleChangeInArray(newData, rememberKey)}
          />
        );
      })} */}
      {Array.isArray(rememberItemsArray) &&
        rememberItemsArray.map((rememberKey) => {
          const rememberArray = currentState?.remember?.[rememberKey];
          if (!Array.isArray(rememberArray)) return null;

          const activitiesNameArray = [];
          if (Array.isArray(activitiesKeyArray)) {
            for (let index = 0; index < activitiesKeyArray.length; index++) {
              const activitiesKey = activitiesKeyArray[index];
              const activity = activitiesObject?.[activitiesKey];
              if (!activitiesKey || !activity?.name) continue;

              activitiesNameArray.push({
                name: activity.name,
                id: activitiesKey
              });
            }
          }

          const rememberNameArray = [];
          for (let index = 0; index < rememberArray.length; index++) {
            const activitiesKey = rememberArray[index];
            const activity = activitiesObject?.[activitiesKey];
            if (!activitiesKey || !activity?.name) continue;

            rememberNameArray.push({
              name: activity.name,
              id: activitiesKey
            });
          }

          return (
            <MultiSelectBox
              key={rememberKey}
              label={rememberKey.split("_").join(" ")}
              options={activitiesNameArray}
              selectedData={item?.activities || []}
              onChange={(newData) => handleChangeInArray(newData, rememberKey)}
            />
          );
        })}
    </div>
  );
};
export default LineStateActivityUpdate;
